export default __webpack_public_path__ + "static/dell-3d6a4a77dc7e18f7f2dedfb678e16164.png";